import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildQueryAndLoadPayPalScript, type Options } from '../utils/buildQueryAndLoadPayPalScript';

export const loadPayPalScript = createAsyncThunk('LOAD_PAYPAL_SCRIPT', (params: Options) => {
  return buildQueryAndLoadPayPalScript(params);
});
